import { dataPrimes } from "../data/dataPrimes";
export var usePriceTable = function () {
    var buildPriceTableFromDataPrimes = function (planId, paymentModeId) {
        // Validate payment mode ID
        if (!paymentModeId) {
            return [];
        }
        // Find the plan in dataPrimes by ID
        var planData = dataPrimes.find(function (plan) { return plan.id === planId; });
        if (!planData || !planData.scenaries) {
            return [];
        }
        // Filter scenaries by payment mode ID
        var filteredScenaries = planData.scenaries.filter(function (scenario) { return scenario.paymentModeId === paymentModeId; });
        // Helper: extract the starting age number from a range string e.g. "30 - 44" → 30
        var getStartAge = function (range) {
            return parseInt(range.split("-")[0].trim(), 10);
        };
        // Map and sort the filtered scenaries by starting age (ascending)
        return filteredScenaries
            .map(function (scenario) { return ({
            id: scenario.id,
            ageRange: scenario.ageRange,
            price: scenario.price || "0.00",
            currencySymbol: scenario.currencySymbol || "RD$",
        }); })
            .sort(function (a, b) { return getStartAge(a.ageRange) - getStartAge(b.ageRange); });
    };
    return {
        buildPriceTableFromDataPrimes: buildPriceTableFromDataPrimes,
    };
};
